import React from 'react';
import Dialog from 'components/Dialog';
import BoxBody from 'components/BoxBody';
import Row from 'components/Row';
import Heading from 'components/Heading';
import Select from 'components/Select';
import Button from 'components/Button';
import Text from 'components/Text';
import ErrorReporter from 'app/components/ErrorReporter';
import CenteredLoadingIndicator from 'components/CenteredLoadingIndicator';
import {
  patchCoach,
} from 'coaching/actions/CoachingActions';
import GetCoachStatusValuesContainer from 'coaching/containers/GetCoachStatusValuesContainer';
import ToastActions from 'actions/ToastActions';

export type Props = {
  onRequestHide: () => void;
  coachUuid: string;
  initialStatus: string;
}

type State = {
  status: string;
  submitting: boolean;
}

const formatStatusOptions = (statuses: string[]) =>
  statuses.map(status => ({ label: status, value: status }));

export default class CoachingUpdateCoachDialog extends React.Component<Props, State> {
  constructor(props: Props) {
    super(props);

    this.state = {
      status: props.initialStatus,
      submitting: false,
    }
  }

  updateCoachStatus = () => {
    const { status } = this.state;
    if (status === this.props.initialStatus) {
      return;
    }

    this.setState({ submitting: true });
    return patchCoach(this.props.coachUuid, { status }).then(this.props.onRequestHide, () =>
      this.setState({ submitting: false })
    );
  }

  render() {
    const { initialStatus } = this.props;

    return (
      <Dialog onRequestHide={this.props.onRequestHide}>
        <GetCoachStatusValuesContainer>
          {({ loading, error, statuses }) => {
            if (loading) {
              return <CenteredLoadingIndicator />;
            }
            if (error || statuses === undefined) {
              ToastActions.showErrorToast('Could not load coach statuses');
              this.props.onRequestHide();
            }

            return (
              <BoxBody>
                <Row size="small">
                  <Heading level="2" serif>
                    Update coach status
                  </Heading>
                  <Text color="thunder">
                    Set a new status for the coach
                  </Text>
                </Row>
                <Row>
                  <Select
                    data-test="coaching-update-coach-status-select"
                    options={formatStatusOptions(statuses!)}
                    onChange={(status: string) => this.setState({ status })}
                    placeholder="Coach Status"
                    value={this.state.status}
                  />
                </Row>
                <Button
                  data-test="coaching-update-coach-status-button"
                  loading={this.state.submitting}
                  disabled={initialStatus === this.state.status}
                  onClick={this.updateCoachStatus}
                >
                    Update status
                </Button>
              </BoxBody>
            );
          }}
        </GetCoachStatusValuesContainer>
      </Dialog>
    )
  }
}
